<template>
    <v-col cols="12" class=" py-0">
        <v-dialog v-model="dialog" persistent max-width="800">
            <v-card :loading="loading">
                <v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:20px">{{ i18n["add_new_settings"] }}
                </v-card-title>
                <v-card-text>
                    <v-row class="align-center">
                        <v-col cols="12" md="6" class="text-center py-1" b-t-n>
                            <v-autocomplete :items="countries" v-model="affilaiteSetting.country_id" :label="i18n['country']"
                                autocomplete="disabled" outlined @click.stop="" :filter="filterObject" hide-details
                                clearable dense :loading="loading" item-value="id"
                                :class="`${arabic ? 'arFont' : 'enFont'}`">
                                <template v-slot:selection="{ attr, on, item, selected }">
                                    <span v-bind="attr" :input-value="selected" v-on="on"
                                        :class="`${arabic ? 'arFont' : 'enFont'}`">
                                        <v-chip x-small>{{ item.name }} | {{ item.id }}</v-chip>
                                    </span>
                                </template>
                                <template v-slot:item="{ item }">
                                    <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                        {{ item.name }} | {{ item.id }}
                                    </span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" class="text-center py-1" b-t-n>
                            <v-autocomplete :items="accounts" v-model="affilaiteSetting.account_id" :label="i18n['account']"
                                autocomplete="disabled" outlined @click.stop="" :filter="filterObject" hide-details
                                clearable dense :loading="loading" item-value="id"
                                :class="`${arabic ? 'arFont' : 'enFont'}`">
                                <template v-slot:selection="{ attr, on, item, selected }">
                                    <span v-bind="attr" :input-value="selected" v-on="on"
                                        :class="`${arabic ? 'arFont' : 'enFont'}`">
                                        <v-chip x-small>{{ item.name }} | {{ item.id }}</v-chip>
                                    </span>
                                </template>
                                <template v-slot:item="{ item }">
                                    <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                        {{ item.name }} | {{ item.id }}
                                    </span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'} py-2`" b-t-n>
                            {{  i18n['settings'] }}
                        </v-col>

                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense
                                v-model="affilaiteSetting.percentage" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                :label="i18n['percentage']" />
                        </v-col>

                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense
                                v-model="affilaiteSetting.commission" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                :label="i18n['commission']" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions :class="`${arabic ? 'arFont' : 'enFont'}`">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text :loading="loading" :class="`${arabic ? 'arFont' : 'enFont'}`"
                        @click="closeDialog">
                        {{ i18n["close"] }}
                    </v-btn>
                    <v-btn v-if="!affilaiteSetting.id" color="success" :loading="loading"
                        :class="`${arabic ? 'arFont' : 'enFont'}`" @click="saveResourceHandler">
                        <v-icon right size="15">
                            save
                        </v-icon>
                        {{ i18n["add_settings"] }}
                            
                    </v-btn>
                    <v-btn v-if="affilaiteSetting.id" color="success" :loading="loading"
                        :class="`${arabic ? 'arFont' : 'enFont'}`" @click="updateResourceHandler">
                        <v-icon right size="15">
                            save
                        </v-icon>
                        {{ i18n["update"] }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-col>
</template>

<script>

import typeMixins from '@/mixings/isType';
import languageMixins from '@/mixings/language';

export default {
  props: ['affilaiteSetting', 'countries', 'accounts', 'loading', 'dialog'],
  mixins: [typeMixins, languageMixins],
  methods: {
    saveResourceHandler() {
      this.$emit('on-save', this.affilaiteSetting);
    },
    updateResourceHandler() {
      this.$emit('on-update', this.affilaiteSetting);
    },
    filterObject(item, queryText, itemText) {
      const v = Object.values(item).filter((x) => typeof x === 'string');
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (itemText && typeof itemText === 'string' && itemText.toLowerCase().includes(queryText
        .toLowerCase())) a = true;
      return a;
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
  },
  computed: {
        api() {
            return this.$store.state.settings.apiBase
        },
        language() {
            return this.$store.state.language
        },
        i18n() {
            return this.$store.state.i18n[this.$store.state.language]
        },
        arabic() {
            if (this.$store.state.language == 'ar') return true
        },
    },
};
</script>

<style>

</style>
